import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import CircumIcon from "@klarr-agency/circum-icons-react";
import Button from '@mui/material/Button';
import { PlusCircle, User } from 'react-feather';
import { Icon } from '@iconify/react';
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';
import { Edit3, Trash2, Eye, Plus, GitPullRequest } from 'react-feather';
import { IconButton, Tooltip, Typography } from '@mui/material';
import Toastmessage from '../../components/Toast';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from 'react-router-dom';
import { authApi } from '../../api/api';
import { useSelector } from 'react-redux';
import { logout } from '../../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { render } from "@testing-library/react";


export default function FamilyTreeTable({apiResponse}) {
    const [rows, setRows] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]); // Store filtered data
    const [searchText, setSearchText] = useState('');
    const [open, setOpen] = useState(false);
    const [deleteLocation, setDeleteLocation] = useState('')

    const token = useSelector((state) => state.auth.token); // Get the token from Redux
    const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        if (apiResponse?.data?.actions?.list) {
        fetchFamilyList();
        }
    }, [token, userID]); // Run effect when token or userID change

    const fetchFamilyList = async () => {
        const input_token = 'FAMILYTREE'; // Replace with your actual token
        const apiUrl = 'family_tree_list'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setRows(data.familyMembers);
                setFilteredRows(data.familyMembers); // Set filtered rows to the same data initially
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }


        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    }



    const columns = [
        {
            field: 'family_name',
            headerName: 'Family Name',
            flex: 0.5,
            renderCell: (params) => (
                <a href="#" className="location-link">
                    {params.value}
                </a>
            )
        },
        {
            field: 'prof',
            headerName: 'Prof Name',
            flex: 0.5,
        },
        {
            field: 'total_family_members',
            headerName: 'Total family members count',
            flex: 0.5,
        },
        {
            field: 'status',
            headerName: 'isActive',
            flex: 0.5,
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.status == 1 ? 'Active' : 'Inactive'}
                    </div>
                )

            }
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 210,
            renderCell: (params) => (
                <>
                 {apiResponse?.data?.actions?.edit && (
                    <Tooltip title="Edit Family" arrow>
                        <IconButton
                            onClick={() => handleClickEdit(`${params.row.id}`)}
                            sx={{
                                backgroundColor: '#F3F4FC',
                                color: '#6A6A6A',
                                borderRadius: '50%',
                                padding: '8px', // Reduce padding size
                                marginRight: '8px',
                            }}
                            size="small" // Decrease the button size
                        >
                            <Edit3 size={16} /> {/* Smaller Feather icon size */}
                        </IconButton>
                    </Tooltip>
                 )}
                  {apiResponse?.data?.actions?.delete && (
                    <Tooltip title="Delete Total Family" arrow>
                        <IconButton
                            onClick={() => handleClickOpen(params.row.id)}
                            sx={{
                                backgroundColor: '#F3F4FC',
                                color: '#6A6A6A',
                                borderRadius: '50%',
                                padding: '8px', // Reduce padding size
                                marginRight: '8px'
                            }}
                            size="small" // Decrease the button size
                        >
                            <Trash2 size={16} /> {/* Smaller Feather icon size */}
                        </IconButton>
                    </Tooltip>
                  )}
                  {apiResponse?.data?.actions?.viewmember && (
                    <Tooltip title="View Family Members" arrow>
                        <IconButton
                            onClick={() => familyMembersList(params.row.id)}
                            sx={{
                                backgroundColor: '#F3F4FC',
                                color: '#6A6A6A',
                                borderRadius: '50%',
                                padding: '8px', // Reduce padding size
                                marginRight: '8px'
                            }}
                            size="small" // Decrease the button size
                        >
                            {/* <Eye size={16} /> */}
                            <Icon icon="basil:user-outline" width="20" height="20" /> {/* Smaller Feather icon size */}
                        </IconButton>
                    </Tooltip>
                  )}
                  {/* {apiResponse?.data?.actions?.addmember && (
                    <Tooltip title="Add Family Members" arrow>
                        <IconButton
                            onClick={() => addFamilyMembers(params.row.id)}
                            sx={{
                                backgroundColor: '#F3F4FC',
                                color: '#6A6A6A',
                                borderRadius: '50%',
                                padding: '8px', 
                                marginRight: '8px'
                            }}
                            size="small" 
                        >
                            <Plus size={16} />
                        </IconButton>
                    </Tooltip>
                  )} */}
                  {/* {apiResponse?.data?.actions?.addmember && (
                    <Tooltip title="Trust List" arrow>
                        <IconButton
                            onClick={() => Trustlist(params.row.id)}
                            sx={{
                                backgroundColor: '#F3F4FC',
                                color: '#6A6A6A',
                                borderRadius: '50%',
                                padding: '8px', // Reduce padding size
                                marginRight: '8px'
                            }}
                            size="small" // Decrease the button size
                        >
                           <Icon icon="solar:hand-heart-line-duotone" width="24" height="24" />
                        </IconButton>
                    </Tooltip>
                  )} */}
                  {apiResponse?.data?.actions?.view && (
                    <Tooltip title="View Family Tree" arrow>
                        <IconButton
                            onClick={() => viewFamilTree(params.row.id)}
                            sx={{
                                backgroundColor: '#F3F4FC',
                                color: '#6A6A6A',
                                borderRadius: '50%',
                                padding: '8px', // Reduce padding size
                            }}
                            size="small" // Decrease the button size
                        >
                            {/* <GitPullRequest size={16} /> Smaller Feather icon size */}
                           <Icon icon="mdi:family-tree" width="16" height="16" />

                        </IconButton>
                    </Tooltip>
                  )}
                </>
            ),
        }
    ];


    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchText(value);
        const filteredRow = filteredRows.filter((row) =>
            row.family_name.toLowerCase().includes(value) // Adjusted to search in userRoll
        );
        setRows(filteredRow);
    };


    // const handleDelete = () => {
    //     const toast = Toastmessage('deleted successfully', true)
    //     setRows((prevRows) => prevRows.filter((row) => row.id !== deleteLocation));
    //     setOpen(false);
    // };

    const handleDelete = async () => {

        const fetchData = async () => {
          const input_token = deleteLocation+'DELETE_FAMILY_TREE';; // Replace with your actual token
          const apiUrl = 'delete_family_tree'; // Replace with the actual API endpoint
    
          const dataInput = {
            login_user_id: userID,
            id:deleteLocation
          };
          try {
            const data = await authApi(input_token, dataInput, apiUrl, token);    
            if (data && data.success) {
              await Toastmessage(data.message, true);
              setOpen(false);
              await fetchFamilyList(); // Refresh the list after deletion
            } else if (data && data.message === 'Token has expired') {
              dispatch(logout());
              localStorage.removeItem('token');
              await Toastmessage('Session expired. Redirecting to login...', false);
              navigate('/login');
            } else if (data === undefined) {
              await Toastmessage('No response from server', false);
            } else {
              await Toastmessage(data?.message || 'An error occurred', false);
            }
          } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
              dispatch(logout());
              localStorage.removeItem('token');
              await Toastmessage('Session expired. Redirecting to login...', false);
              navigate('/login');
            } else {
              await Toastmessage('Something went wrong', false);
            }
          }
        }
    
        // Call the function to make the API call
        await fetchData();
      };

    const handleClickOpen = (id) => {
        setOpen(true);
        setDeleteLocation(id)

    };

    const handleClose = () => {
        setOpen(false);
    };

    const viewFamilTree = (id) => {
        navigate('/viewfamilytree', { state: { treeId: id } });
    }
    const Trustlist = (id) => {
        navigate('/trustlist', { state: { treeId: id } });
    }

    const addFamilyMembers = (id) => {
        navigate('/createmember', { state: { treeId: id } });
    }

    const familyMembersList = (id) => {
        navigate('/memberslist', { state: { treeId: id } });
    }

    const handleClickEdit = (id) => {
        navigate('/editfamilytree', { state: { treeId: id } });
    };

    return (
        <Box className="familytree-container">

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={12} color="var(--text-color)">
                        Family Tree
                    </Typography>
                </Box>

                {/* Right Section */}
                {apiResponse?.data?.actions?.add && (
                <Button
                    variant="outlined"
                    component={Link}
                    to="/createfamily"
                    sx={{
                        backgroundColor: 'var(--back-button)',
                        color: "var(--back-color)",
                        fontWeight: 'bold',
                        border: 'none',
                        padding: '10px 20px'
                    }}
                    startIcon={<PlusCircle sx={{ fontSize: 17 }} />}
                    style={{ textTransform: 'none' }}
                >
                    Create New Family
                </Button>
                )}
            </Box>

            <Box p={3}>
                <Box className="location-header " >
                    <h6>Total Family Tree </h6>
                    <TextField
                        label="Search family name"
                        variant="outlined"
                        value={searchText}
                        onChange={handleSearch}
                        className="search-input"
                    />
                </Box>
                <div sx={{ m: 0, p: 0 }}>
                    <Box sx={{ width: '100%', display: 'flex' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            pageSize={5}
                            autoHeight
                            pagination
                            disableSelectionOnClick
                            rowsPerPageOptions={[]}
                            className="data-grid"
                            sx={{ width: '100%' }} // Ensure DataGrid takes full width
                        />
                    </Box>
                </div>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Confirm Deletion?"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to delete this family tree?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Disagree</Button>
                        <Button onClick={handleDelete} autoFocus>
                            Agree
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </Box>

    )
}